
import './styles/main.scss';

console.log('Project started!')